import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import BaseModal from '../../BaseModal';
import {
  clearPerformanceModalFilters,
  setPerformanceModals,
} from '@/store/slices/components/dashboard/DashboardSlice';
import buildQuery from '@/components/Dashboard/utils/buildQuery';
import { getPerformanceAddedPropertiesTable } from '@/store/slices/components/dashboard/service';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DownloadButton from '@/components/Dashboard/DashboardTables/components/DownloadButton';
import styles from '../../performanceModals.module.scss';
import buildTableQuery from '@/components/Dashboard/utils/buildTableQuery';
import useAsyncTableExcelDownload from '@/components/Dashboard/customHooks/useAsyncTableExcelDownload';
import { TABLES } from '@/components/Dashboard/constants';
import TableSearchEmptyState from '@/components/Dashboard/DashboardTables/TableSearchEmptyState';
import SearchInput from '../../SearchInput';
import { addedPropertiesTypesOptions } from '../utils';
import AddedPropertiesTable from '@/components/Dashboard/DashboardTables/AddedPropertiesTable';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

export default function AddedPropertiesModal() {
  const dispatch = useDispatch();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { addedProperties } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const {
    count,
    list,
    loading,
    sortBy,
    sortDirection,
    searchQuery,
    searchTypeFlag,
  } = addedProperties;
  const track = useTrackPerformanceTable();
  const { handleDownloadExcel: downloadExcel, isDownloading } =
    useAsyncTableExcelDownload(TABLES.ADDED_PROPERTIES);

  useEffect(() => {
    const fetchData = () => {
      const query = buildQuery(selectedIds);
      const tableQuery = buildTableQuery(addedProperties);

      dispatch(getPerformanceAddedPropertiesTable({ query, tableQuery }));
    };

    fetchData();
  }, [sortBy, sortDirection, searchQuery, searchTypeFlag]);

  const handleDownloadExcel = () => {
    const query = buildQuery(selectedIds);
    const tableQuery = buildTableQuery(addedProperties);
    downloadExcel(query, tableQuery);
    track.addedProperties(TRACK_ELEMENT.DOWNLOAD_BUTTON);
  };

  const handleClearFilters = () => {
    const modal = 'addedProperties';
    const filters = ['searchQuery', 'searchType'];
    dispatch(clearPerformanceModalFilters({ modal, filters }));
  };

  return (
    <BaseModal
      id="added-properties-modal"
      title={Trans(translations, 'CountEnteredProperties', count || '0')}
      handleClose={() =>
        dispatch(
          setPerformanceModals({
            key: 'addedProperties',
            subkey: 'isOpen',
            value: false,
          })
        )
      }
    >
      <Box className={styles.modalControls}>
        <SearchInput
          modal="addedProperties"
          dropdownOptions={addedPropertiesTypesOptions}
        />

        <DownloadButton
          onClick={handleDownloadExcel}
          disabled={isDownloading}
        />
      </Box>
      {searchQuery && list?.length === 0 && !loading ? (
        <TableSearchEmptyState onClearFilters={handleClearFilters} />
      ) : (
        <BaseModal.TableContainer>
          <AddedPropertiesTable />
        </BaseModal.TableContainer>
      )}
    </BaseModal>
  );
}
